import Vue from 'vue';
import router from '../router';
import { Route } from 'vue-router';
import { UNIT_INVOICE_SETTINGS } from '@/queries/CompanySetting';
import Popup from '@/components/UI/Popup/Popup';
import i18n from '@/i18n';

const unitInvoiceSettingsRequiredGuard = (
  to: Route,
  from: Route,
  next: (to?: string | false | void | ((vm: Vue) => void)) => void,
): void => {
  const loader = router.app.$sLoader({
    show: true,
    fullPage: true,
    element: router.app.$el as HTMLElement,
  });

  router.app.$apollo
    .query({
      query: UNIT_INVOICE_SETTINGS,
    })
    .then(({ data }) => {
      if (!data.currentUnit.unitSetting.unitInvoiceSetting.id) {
        next(false);
        router.push(
          { name: 'CompanySettings' },
          () => Popup.alert(i18n.t('Company.Setting.setCompanySettings'), {
            title: i18n.t('Company.Setting.setCompanySettingsTitle'),
            withCloseButton: false,
            buttons: [ { text: 'OK', color: 'success', click: () => { } } ],
          }),
        );
      } else {
        next();
      }
    }).finally(() => {
      loader.show = false;
    });
};

export default unitInvoiceSettingsRequiredGuard;
